<div class="page-wrapper">
  <div [class.mobile]="deviceSvc.isMobile"
       class="page">
    <app-menu></app-menu>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
</div>

@if (deviceSvc.hamburgerMenu) {
  <app-hamburger-menu></app-hamburger-menu>
}